import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'talk-to-your-data-collapsible-section',
  templateUrl: './collapsible-section.component.html',
  styleUrls: ['./collapsible-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsibleSectionComponent {
  @Input() title = '';

  @Input() count: number | null = null;

  @Input() icon: string | null = null;

  @Input() collapsed = false;

  toggle(): void {
    this.collapsed = !this.collapsed;
  }
}
